import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataFilterDisplayService } from '../../interface';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ConnectionsOptionsDisplayService implements DataFilterDisplayService {
  constructor(private readonly translateService: TranslateService) {}

  getDisplay(values: string[]): Observable<string> {
    if (values?.length === 0) {
      return of(`<b>${this.translateService.instant('AUTOMATIONS.EDITOR.FILTERS.CONNECTIONS_DATA.NONE')}</b>`);
    }

    let result = '';

    values.map((v) => {
      if (result.length !== 0) {
        result += ', ';
      }
      result += this.translateService.instant('AUTOMATIONS.EDITOR.FILTERS.CONNECTIONS_DATA.' + v.toUpperCase());
    });

    return of(`<b>${result}</b>`);
  }
}
